// extracted by mini-css-extract-plugin
export default {"robotImage":"RobotImage_robotImage__bVJIf"};